export function startCase(value?: any) {
  if (!value) {
    return ''
  }
  return typeof value === 'string'
    ? value
        .toLowerCase()
        .replaceAll('_', ' ')
        .replaceAll(/\b\w/g, (l) => l.toUpperCase())
    : value
}
